import { render, staticRenderFns } from "./Smiley.vue?vue&type=template&id=c9d09bcc&"
import script from "./Smiley.vue?vue&type=script&setup=true&lang=js&"
export * from "./Smiley.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports